import {Component, Input, ChangeDetectionStrategy, OnChanges, ChangeDetectorRef} from '@angular/core';
import { ActivityDetails } from '@features/invoices/models/invoice-activity-details.model';
import { InvoiceActivityStatus } from '@shared-features/enums/shared-enums.enum';

@Component({
  selector: 'app-activity-card',
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class activityCardComponent implements OnChanges {
  @Input() activityData: ActivityDetails[];
  @Input() isCardHasTitle = true;

  invoiceActivityStatus = InvoiceActivityStatus

  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  ngOnChanges() {
    this.changeDetectorRef.markForCheck();
  }
}


